module.exports = __webpack_public_path__ + "media/vvv-dashboard-guide-ru.c6cb93ad.mp4";